import React from "react";
import { SectionContentProps } from "../../types";
import EditableText from "../../core/EditableText";
import { PiPlayCircle } from "react-icons/pi";

export default function VideoSection({ content, onContentChange, isSelected }: SectionContentProps) {
    const primaryColor = content.colorPalette?.primary || "#111827";
    const fontFamily = content.fontFamily || "inherit";
    const videoUrl = content.videoUrl || "https://www.youtube.com/embed/dQw4w9WgXcQ?si=DyvB6s0gO7_2_9tG";
    const coverImage = content.coverImage || "https://images.unsplash.com/photo-1536240478700-b869070f9279?auto=format&fit=crop&q=80&w=1600";
    const [isPlaying, setIsPlaying] = React.useState(false);

    return (
        <section className={`px-6 py-24 bg-white ${isSelected ? "ring-2 ring-blue-500" : ""}`} style={{ fontFamily }}>
            <div className="max-w-6xl mx-auto">
                <div className="text-center mb-12">
                    <h2 className="text-4xl font-black text-gray-900 tracking-tight mb-4">
                        <EditableText value={content.title || "Watch Our Story"} onChange={(v) => onContentChange?.({ ...content, title: v })} />
                    </h2>
                    <p className="text-xl text-gray-500 max-w-2xl mx-auto">
                        <EditableText value={content.subtitle || "See how we are changing the world, one line of code at a time."} onChange={(v) => onContentChange?.({ ...content, subtitle: v })} />
                    </p>
                </div>

                <div className="relative aspect-video rounded-3xl overflow-hidden shadow-2xl bg-gray-900 group">
                    {!isPlaying ? (
                        <>
                            <img src={coverImage} alt="Video Cover" className="w-full h-full object-cover opacity-60 group-hover:opacity-40 transition-opacity" />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <button
                                    onClick={() => setIsPlaying(true)}
                                    className="w-20 h-20 md:w-24 md:h-24 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white transition-all hover:scale-110 hover:bg-white/30"
                                >
                                    <PiPlayCircle className="w-full h-full p-2" />
                                </button>
                            </div>
                            <div className="absolute bottom-6 left-6 md:bottom-10 md:left-10 text-white">
                                <p className="font-bold text-lg">{content.videoLabel || "Introduction"}</p>
                                <p className="text-sm opacity-70">{content.duration || "2:45 min"}</p>
                            </div>
                        </>
                    ) : (
                        <iframe
                            src={`${videoUrl}${videoUrl.includes('?') ? '&' : '?'}autoplay=1`}
                            title="Video player"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                            className="w-full h-full absolute inset-0 border-0"
                        ></iframe>
                    )}
                </div>
            </div>
        </section>
    );
}
